export default __webpack_public_path__ + "static/media/spire_logo.5a59332b.png";